import PanoramaController from '../controllers/panorama_controller.js';
export default PanoramaController;
